// News all slider
new Splide( '#news',{
    //padding: '2rem',
    trimSpace: false,
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: true,
    type: 'loop',
    type: 'fade',
    //direction   : 'ttb',
    arrowPath: 'M0 7.00008V9.00008H12L6.5 14.5001L7.92 15.9201L15.84 8.00008L7.92 0.0800781L6.5 1.50008L12 7.00008H0Z',

    breakpoints: {
        1280: {
            perPage: 1,
        },
        860: {
            perPage: 1,
        },
        580: {
            perPage: 1,
        },
    },

    classes: {
    },
    classes: {
        arrows: 'splide__arrows flex',
        arrow : 'splide__arrow items-center',
        prev  : 'splide__arrow--prev icon-chevron-left',
        next  : 'splide__arrow--next icon-chevron-right',
    },
} ).mount();

//# sourceMappingURL=splide-control-news.js.map
